<h1 mat-dialog-title>Attach a file <span tabindex="0" role="button" (click)="onNoClick()" (keyup.enter)="onNoClick()"
    class="close">Close X</span></h1>

<form [formGroup]="fileForm">
    <mat-dialog-content aria-live="polite">
        <mat-card appearance="outlined" class="af-mat-card mat-elevation-z">
            <mat-card-header>
                <div mat-card-avatar class="example-header-image">
                    <img alt="information" src="assets/bofa_icon_info.svg" class="img-size">
                </div>
                <mat-card-title class="zoom-text-dialog">Allowed file formats</mat-card-title>
            </mat-card-header>
            <mat-card-content>
                <p class="bofa--heading is-9">ZIP, PDF, DOC, DOCX, EML, MSG, TIFF, JPEG, GIF, XLS, XLSX, PNG, JPG, PPT and PPTX
                </p>
            </mat-card-content>
        </mat-card>
        <div class="padd-15">
            <app-file-upload   [disputeFileUpload]="disputeFileUpload" [verifyId]="verifyId"></app-file-upload>
        </div>

    </mat-dialog-content>
    <mat-dialog-actions align="end">
        <div class="is-taller">
            <div class="level">
                <div class="level-item">
                    <button class="bofa--button secondary outlined" type="button" (click)="onNoClick()">Cancel</button>
                </div>

                <div class="level-item">
                    <button class="bofa--button secondary" type="button" [disabled]="fileForm.invalid || inProgress"
                        (click)="uploadClick()">Upload</button>
                </div>
            </div>
        </div>
    </mat-dialog-actions>
</form>
